import React, { useState, useEffect, useMemo } from 'react';
import './Hero.css';

const Hero = () => {
  const [displayText, setDisplayText] = useState('');
  const [lineIndex, setLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const commands = useMemo(() => [
    { cmd: 'ping afracell.com', out: '64 bytes from afracell.com: time=12.3ms' },
    { cmd: 'nmap -sV 185.xxx.xxx.1', out: '22/tcp open  SSH  OpenSSH 8.9p1' },
    { cmd: 'curl -I https://afracell.com', out: 'HTTP/2 200 OK  |  Server: nginx/1.24' },
    { cmd: 'systemctl status nginx', out: 'active (running) since 2025-01-01' },
  ], []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    const currentLine = commands[lineIndex];
    if (!currentLine) return;

    const fullText = `$ ${currentLine.cmd}\n  ${currentLine.out}`;
    const typingSpeed = isDeleting ? 30 : 60;

    const timer = setTimeout(() => {
      if (!isDeleting) {
        if (charIndex < fullText.length) {
          setDisplayText(prev => prev + fullText[charIndex]);
          setCharIndex(prev => prev + 1);
        } else {
          setIsDeleting(true);
        }
      } else {
        if (charIndex > 0) {
          setDisplayText(prev => prev.slice(0, -1));
          setCharIndex(prev => prev - 1);
        } else {
          setIsDeleting(false);
          setLineIndex(prev => (prev + 1) % commands.length);
          setDisplayText('');
          setCharIndex(0);
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timer);
  }, [charIndex, isDeleting, lineIndex, commands]);

  return (
    <section className="hero" id="home">
      <div className="hero-bg"></div>
      <div className="grid-lines"></div>
      <div className="wrap">
        <div className="hero-inner">
          <div>
            <div className="hero-badge">
              زیرساخت دیجیتال حرفه‌ای
            </div>
            <h1 className="hero-h1">
              زیرساخت ابری <em>سریع، امن</em> و <em>مقیاس‌پذیر</em>
            </h1>
            <p className="hero-sub">
              از سرور مجازی تا هاستینگ مدیریت‌شده و ثبت دامنه — همه چیز برای رشد کسب‌وکار شما در یک جای امن.
            </p>
            <div className="hero-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('services')}>
                شروع کنید
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                مشاوره رایگان
              </button>
            </div>
            <div className="hero-stats">
              <div>
                <span className="hstat-n">۹۹.۹٪</span>
                <span className="hstat-l">آپتایم تضمینی</span>
              </div>
              <div className="hstat-sep"></div>
              <div>
                <span className="hstat-n">۵۰۰+</span>
                <span className="hstat-l">مشتری فعال</span>
              </div>
              <div className="hstat-sep"></div>
              <div>
                <span className="hstat-n">۲۴/۷</span>
                <span className="hstat-l">پشتیبانی فارسی</span>
              </div>
            </div>
          </div>
          <div className="terminal">
            <div className="term-bar">
              <span className="tdot td1"></span>
              <span className="tdot td2"></span>
              <span className="tdot td3"></span>
              <span className="term-title">bash — افراسل</span>
            </div>
            <div className="term-body">
              <div className="term-line">
                <span className="prompt">$</span>
                <span className="cmd">whoami</span>
              </div>
              <div className="term-line">
                <span className="out ok">root@afracell-core</span>
              </div>
              {displayText.split('\n').map((line, idx) => {
                if (line.startsWith('$')) {
                  return (
                    <div key={idx} className="term-line">
                      <span className="prompt">$</span>
                      <span className="cmd">{line.substring(2)}</span>
                    </div>
                  );
                } else if (line.trim()) {
                  return (
                    <div key={idx} className="term-line">
                      <span className="out ok">{line}</span>
                    </div>
                  );
                }
                return null;
              })}
              <span className="cursor"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
